import { CURRENT_SERVER } from '@/constants/domains'
import VueCookie from 'vue-cookie'
const axios = require('axios')

export default {
  getEmailStats ({
    page = 1,
    limit = 30,
    sort = 'timeOfGetMessage&sort[]=-1',
    status,
    filterByDate,
    user}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    const query = [`page=${page}`, `limit=${limit}`, `sort[]=${sort}`]
    if (user) query.push(`user[]=${user}`)
    if (status) query.push(`status[]=${status.join('&status[]=')}`)
    if (filterByDate) query.push(`timeOfGetMessage=${filterByDate}`)
    const url = 'usermessages'
    return instCred.get(`${url}?${query.join('&')}`)
  },
  getEmailStatsTotal ({page = 1, limit = 30, sort, search}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    const query = [`page=${page}`, `limit=${limit}`]
    if (search) query.push(`search=${search}`)
    if (sort) query.push(`sort[]=${sort}`)
    const url = 'usermessages/total'
    return instCred.get(`${url}?${query.join('&')}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/EmailStats/api.js